import type { LeadItem } from "../types/lead.types";

type BuildingOption = {
	id: string;
	name: string;
};

const monthLabels = [
	"yanvar",
	"fevral",
	"mart",
	"aprel",
	"may",
	"iyun",
	"iyul",
	"avgust",
	"sentyabr",
	"oktyabr",
	"noyabr",
	"dekabr",
];

export function hydrateLeadDisplayData(leads: LeadItem[], buildings: BuildingOption[]): LeadItem[] {
	const buildingsById = new Map(buildings.map((building) => [building.id, building.name]));

	return leads.map((lead) => ({
		...lead,
		buildingName:
			lead.buildingName || (lead.buildingId ? (buildingsById.get(lead.buildingId) ?? "") : ""),
	}));
}

export function getLeadManagerLabel(lead: LeadItem) {
	return lead.managerName.trim() || "Biriktirilmagan";
}

export function applyLeadManagerDisplay(lead: LeadItem, managerName: string) {
	const trimmedName = managerName.trim();

	if (!trimmedName) {
		return lead;
	}

	const initials = trimmedName
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map((part) => part[0]?.toUpperCase() ?? "")
		.join("");

	return {
		...lead,
		managerName: lead.managerName.trim() || trimmedName,
		managerInitials: lead.managerInitials.trim() || initials,
	};
}

export function preserveLeadManagerDisplay(updatedLead: LeadItem, currentLead: LeadItem) {
	if (updatedLead.managerName.trim()) {
		return updatedLead;
	}

	if (!currentLead.managerName.trim()) {
		return updatedLead;
	}

	return {
		...updatedLead,
		managerName: currentLead.managerName,
		managerInitials: currentLead.managerInitials,
	};
}

export function formatLeadActivity(value: string) {
	const match = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2})/);

	if (!match) {
		return value;
	}

	const [, , month, day, time] = match;
	const monthIndex = Number(month) - 1;
	const monthLabel = monthLabels[monthIndex];

	if (!monthLabel) {
		return value;
	}

	return `${Number(day)}-${monthLabel}, ${time}`;
}
